// Custom debug logging function
function debugLog(...args) {
    const custom = document.getElementById("gift-script");
    if (custom?.hasAttribute("debug_gift")) {
      console.log(...args);
    }
}
 
// Global gift tracker
var gift = {
    freeItemAdded: false,
    cartUpdated: function () {
        debugLog("🛒 Item added to cart");
    },
};
 
document.addEventListener("DOMContentLoaded", function () {
    // CONFIGURATION
    const giftRuleConfig = window.theme?.settings?.giftRuleConfig || {}; // Default to an empty object if undefined
 
    // Support both tiered and single gift configurations
    let GIFT_TIERS = [];
    if (giftRuleConfig.tiers && Array.isArray(giftRuleConfig.tiers)) {
        // New tiered configuration - sort by spend_threshold descending (highest first)
        GIFT_TIERS = giftRuleConfig.tiers.sort((a, b) => b.spend_threshold - a.spend_threshold);
    } else if (giftRuleConfig.free_gift_variant_id) {
        // Legacy single gift configuration - maintain backward compatibility
        GIFT_TIERS = [{
            spend_threshold: giftRuleConfig.spend_threshold || 0,
            free_gift_variant_id: giftRuleConfig.free_gift_variant_id,
            quantity_threshold: giftRuleConfig.quantity_threshold || 1,
            repeat: giftRuleConfig.repeat || false
        }];
    }
 
    // Get all possible gift variant IDs for tier management
    const ALL_GIFT_VARIANT_IDS = GIFT_TIERS.map(tier => tier.free_gift_variant_id);
 
    // Global configuration (applies to all tiers unless tier-specific override exists)
    const QUANTITY_THRESHOLD = giftRuleConfig.quantity_threshold || 1;
    const REPEAT_GIFT = giftRuleConfig.repeat || false;
    const ELIGIBLE_COUNTRIES = giftRuleConfig.eligible_countries || []; // Default to empty array if undefined
    const ELIGIBLE_CUSTOMER_TAGS = giftRuleConfig.eligible_customer_tags || []; // Default to empty array if undefined
    const ELIGIBLE_COLLECTION_HANDLES = giftRuleConfig.eligible_collection_handles || []; // Default to empty array if undefined
    const START_DATE = giftRuleConfig.start_date ? new Date(giftRuleConfig.start_date) : null; // Default to null if undefined
    const END_DATE = giftRuleConfig.end_date ? new Date(giftRuleConfig.end_date) : null; // Default to null if undefined
 
    // Log the configuration to help with debugging
    debugLog("🔧 Configuration:", {
        GIFT_TIERS,
        ALL_GIFT_VARIANT_IDS,
        QUANTITY_THRESHOLD,
        REPEAT_GIFT,
        ELIGIBLE_COUNTRIES,
        ELIGIBLE_CUSTOMER_TAGS,
        ELIGIBLE_COLLECTION_HANDLES,
        START_DATE,
        END_DATE
    });
 
    // Check if there are any gift tiers configured
    if (!GIFT_TIERS || GIFT_TIERS.length === 0) {
        console.error("Gift rule configuration is missing gift tiers or free gift variant ID.");
        return; // Exit early if no gift configuration is provided
    }
 
    let isProcessing = false;
 
    // Fetch the current cart
    function fetchCart() {
        return fetch("/cart.js")
        .then((res) => res.json())
        .catch((err) => console.error("Error fetching cart:", err));
    }
 
    // Add the free gift to cart with specific quantity
    function addFreeGift(variantId, quantity = 1) {
        gift.freeItemAdded = true;
        const body = JSON.stringify({
            id: variantId,
            quantity: quantity,
            sections: ['main-cart', 'cart-drawer', 'cart-bubble'],
            sections_url: window.location.pathname
        });
 
        return fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: body
        })
        .then((response) => response.text())
        .then((state) => {
            const parsedState = JSON.parse(state);
            renderCartSections(parsedState);
        })
        .catch((err) => {
            console.error("Error adding gift:", err);
        });
    }
 
    // Update free gift quantity in cart
    function updateFreeGiftQuantity(lineItemKey, newQuantity) {
        const body = JSON.stringify({
            id: lineItemKey,
            quantity: newQuantity,
            sections: ['main-cart', 'cart-drawer', 'cart-bubble'],
            sections_url: window.location.pathname
        });
 
        return fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: body
        })
        .then((response) => response.text())
        .then((state) => {
            const parsedState = JSON.parse(state);
            renderCartSections(parsedState);
        })
        .catch((err) => {
            console.error("Error updating gift quantity:", err);
        });
    }
 
    // Remove the free gift from cart
    function removeFreeGift(lineItemKey) {
        const body = JSON.stringify({
            id: lineItemKey,
            quantity: 0,
            sections: ['main-cart', 'cart-drawer', 'cart-bubble'],
            sections_url: window.location.pathname
        });
 
        return fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: body
        })
        .then((response) => response.text())
        .then((state) => {
            const parsedState = JSON.parse(state);
            renderCartSections(parsedState);
        })
        .catch((err) => {
            console.error("Error removing gift:", err);
        });
    }
 
    // Helper function to get section inner HTML (matches CartDrawer implementation)
    function getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }
 
    // Render cart sections - following the same pattern as CartDrawer.updateQuantity()
    function renderCartSections(parsedState) {
        // Update cart count
        const cartCountElement = document.querySelector(".cart-count");
        if (cartCountElement && parsedState.item_count !== undefined) {
            cartCountElement.textContent = parsedState.item_count;
        }
 
        // Define sections to render (matching CartDrawer.getSectionsToRender())
        const sectionsToRender = [
            {
                id: 'Cart',
                section: 'main-cart',
                selector: '.thb-cart-form'
            },
            {
                id: 'Cart-Drawer',
                section: 'cart-drawer',
                selector: '.cart-drawer'
            },
            {
                id: 'cart-drawer-toggle',
                section: 'cart-bubble',
                selector: '.thb-item-count'
            }
        ];
 
        // Update each section if present (matching CartDrawer logic)
        if (parsedState.sections) {
            sectionsToRender.forEach((section) => {
                const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
 
                if (elementToReplace && parsedState.sections[section.section]) {
                    elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }
            });
        }
 
        // Reinitialize Cart and CartDrawer to reattach event listeners (matching CartDrawer logic)
        if (typeof Cart !== 'undefined' && document.getElementById('Cart')) {
            new Cart();
        }
        if (typeof CartDrawer !== 'undefined' && document.getElementById('Cart-Drawer')) {
            new CartDrawer();
        }
 
        // Fire update event for other listeners
        dispatchCustomEvent('line-item:change:end', {
            quantity: parsedState.item_count,
            cart: parsedState
        });
    }
 
    // Fetch collection data for a list of product GIDs
    async function fetchEligibleCollections(productGIDs) {
        try {
            if (!Array.isArray(productGIDs) || productGIDs.length === 0) {
                debugLog("⚠️ No product GIDs provided for collection check.");
                return [];
            }
    
            const queryParam = productGIDs.map(encodeURIComponent).join(",");
            const res = await fetch(`/apps/discounts/collection-check?product_ids=${queryParam}`);
            // If the response is not ok (e.g., status code is not 2xx), throw an error
            if (!res.ok) {
                throw new Error(`Failed to fetch, status: ${res.status}`);
            }
            const { data } = await res.json();
            return data;
        } catch (err) {
            console.error("❌ Error fetching collection data:", err);
            return [];
        }
    }
 
    // Determine which gift tier the customer qualifies for based on spend amount
    function getQualifyingTier(eligibleTotal, eligibleItems) {
        // Find the highest tier that the customer qualifies for
        for (const tier of GIFT_TIERS) {
            const tierThreshold = tier.spend_threshold || 0;
            const tierQuantityThreshold = tier.quantity_threshold || QUANTITY_THRESHOLD;
            const totalEligibleQuantity = eligibleItems.reduce((sum, item) => sum + item.quantity, 0);
 
            if (eligibleTotal >= tierThreshold && totalEligibleQuantity >= tierQuantityThreshold) {
                return tier;
            }
        }
        return null; // No tier qualifies
    }
 
    // Calculate how many free gifts should be given based on eligible items and tier config
    function calculateRequiredGiftQuantity(eligibleItems, tier) {
        if (!tier) return 0;
 
        const tierQuantityThreshold = tier.quantity_threshold || QUANTITY_THRESHOLD;
        const totalEligibleQuantity = eligibleItems.reduce((sum, item) => sum + item.quantity, 0);
 
        // Check if threshold is met
        if (eligibleItems.length === 0 || totalEligibleQuantity < tierQuantityThreshold) {
            return 0;
        }
 
        // Check if repeat is enabled (must be explicitly set to true)
        const tierRepeat = tier.repeat === true || (tier.repeat === undefined && REPEAT_GIFT === true);
 
        if (tierRepeat) {
            // Repeat behavior: gift quantity based on eligible item quantities
            return Math.floor(totalEligibleQuantity / tierQuantityThreshold);
        }
 
        // Default behavior: only 1 gift regardless of quantity (for tiered GWP)
        return 1;
    }
 
    // Main function to check eligibility and apply/remove the gift
    async function checkAndApplyGift() {
        if (isProcessing) {
            debugLog("⏳ Already processing, skipping...");
            return;
        }
 
        // Set processing flag immediately to prevent concurrent execution
        isProcessing = true;
 
        const cart = await fetchCart();
        if (!cart || !Array.isArray(cart.items)) {
            console.error("⚠️ Cart data is missing or invalid:", cart);
            isProcessing = false;
            return;
        }
 
        const now = new Date();
        const timeEligible = (!START_DATE || now >= START_DATE) && (!END_DATE || now <= END_DATE);
 
        const customerCountry = window.theme?.settings?.customer_country_code || "";
        const customerTags = window.theme?.settings?.customer_tags || [];
        const countryEligible = ELIGIBLE_COUNTRIES.length === 0 || ELIGIBLE_COUNTRIES.includes(customerCountry);
        const tagEligible = ELIGIBLE_CUSTOMER_TAGS.length === 0 ||
        customerTags.some((tag) =>
            ELIGIBLE_CUSTOMER_TAGS.includes(tag)
        );
 
        // Find all gift items currently in cart (from any tier)
        const giftItemsInCart = cart.items.filter((item) => ALL_GIFT_VARIANT_IDS.includes(item.variant_id));
 
        if (!timeEligible) {
            // Remove all gift items if not time eligible
            for (const giftItem of giftItemsInCart) {
                await removeFreeGift(giftItem.key);
            }
            isProcessing = false;
            return;
        }
 
        // Get all cart product GIDs excluding all free gifts
        const cartProductGIDs = cart.items
        .filter((item) => !ALL_GIFT_VARIANT_IDS.includes(item.variant_id) && item.product_id)
        .map((item) => `gid://shopify/Product/${item.product_id}`);
 
        const collectionData = await fetchEligibleCollections(cartProductGIDs);
        // Map product ID to whether it belongs to an eligible collection
        const eligibleProductIds = Array.isArray(collectionData)
        ? collectionData
            .filter((product) =>
                Array.isArray(product?.collections) &&
                product.collections.some((collection) =>
                    ELIGIBLE_COLLECTION_HANDLES.includes(collection?.handle)
                )
            )
            .map((product) => {
                const id = product?.id?.split("/").pop();
                return parseInt(id, 10);
            })
            .filter((id) => !isNaN(id)) //This filters out those bad results: [123456, NaN, 7890].filter((id) => !isNaN(id)) // → [123456, 7890]
        : [];
 
        // Get eligible items (from eligible collections)
        const eligibleItems = cart.items.filter(
            (item) =>
            !ALL_GIFT_VARIANT_IDS.includes(item.variant_id) &&
            eligibleProductIds.includes(item.product_id)
        );
 
        // Calculate total only for eligible collection products
        const eligibleCollectionTotal = eligibleItems
        .reduce((sum, item) => sum + (item.line_price || 0), 0) / 100;
 
        // Determine which tier the customer qualifies for
        const qualifyingTier = getQualifyingTier(eligibleCollectionTotal, eligibleItems);
 
        // Calculate required gift quantity based on the qualifying tier
        const requiredGiftQuantity = calculateRequiredGiftQuantity(eligibleItems, qualifyingTier);
 
        debugLog("📊 Eligibility check:", {
            timeEligible,
            countryEligible,
            tagEligible,
            eligibleCollectionTotal,
            allTiers: GIFT_TIERS.map(t => ({ threshold: t.spend_threshold, variant: t.free_gift_variant_id })),
            qualifyingTier: qualifyingTier ? {
                spend_threshold: qualifyingTier.spend_threshold,
                free_gift_variant_id: qualifyingTier.free_gift_variant_id
            } : null,
            eligibleItemsCount: eligibleItems.length,
            totalEligibleQuantity: eligibleItems.reduce((sum, item) => sum + item.quantity, 0),
            requiredGiftQuantity,
            giftItemsInCart: giftItemsInCart.map(g => ({ variant_id: g.variant_id, quantity: g.quantity })),
            cartTotal: cart.total_price / 100
        });
 
        const isEligible =
            timeEligible &&
            countryEligible &&
            tagEligible &&
            qualifyingTier &&
            requiredGiftQuantity > 0;
 
        if (isEligible && qualifyingTier) {
            // Find the correct gift item for this tier
            const correctGiftItem = giftItemsInCart.find((item) => item.variant_id === qualifyingTier.free_gift_variant_id);
            const wrongGiftItems = giftItemsInCart.filter((item) => item.variant_id !== qualifyingTier.free_gift_variant_id);
 
            debugLog("🎯 Gift state analysis:", {
                correctGiftVariantId: qualifyingTier.free_gift_variant_id,
                correctGiftInCart: correctGiftItem ? { variant: correctGiftItem.variant_id, qty: correctGiftItem.quantity } : null,
                wrongGiftsInCart: wrongGiftItems.map(g => ({ variant: g.variant_id, qty: g.quantity })),
                requiredQty: requiredGiftQuantity
            });
 
            // Check if we need to make any changes
            const hasCorrectGift = correctGiftItem && correctGiftItem.quantity === requiredGiftQuantity;
            const hasWrongGifts = wrongGiftItems.length > 0;
 
            if (hasCorrectGift && !hasWrongGifts) {
                // Perfect state - no changes needed
                debugLog("✅ Gift state is already correct");
            } else {
                // Need to make changes - remove wrong gifts first
                if (hasWrongGifts) {
                    // Remove all wrong gifts in sequence
                    for (const wrongGift of wrongGiftItems) {
                        debugLog(`  - Removing variant ${wrongGift.variant_id}`);
                        await removeFreeGift(wrongGift.key);
                    }
                }
 
                // Now handle the correct gift (fetch fresh cart only if we removed gifts)
                if (hasWrongGifts) {
                    const updatedCart = await fetchCart();
                    const updatedGiftItems = updatedCart.items.filter((item) => ALL_GIFT_VARIANT_IDS.includes(item.variant_id));
                    const updatedCorrectGift = updatedGiftItems.find((item) => item.variant_id === qualifyingTier.free_gift_variant_id);
 
                    if (!updatedCorrectGift && requiredGiftQuantity > 0) {
                        await addFreeGift(qualifyingTier.free_gift_variant_id, requiredGiftQuantity);
                    } else if (updatedCorrectGift && updatedCorrectGift.quantity !== requiredGiftQuantity) {
                        await updateFreeGiftQuantity(updatedCorrectGift.key, requiredGiftQuantity);
                    }
                } else {
                    // No wrong gifts removed, use original cart data
                    if (!correctGiftItem && requiredGiftQuantity > 0) {
                        await addFreeGift(qualifyingTier.free_gift_variant_id, requiredGiftQuantity);
                    } else if (correctGiftItem && correctGiftItem.quantity !== requiredGiftQuantity) {
                        await updateFreeGiftQuantity(correctGiftItem.key, requiredGiftQuantity);
                    }
                }
            }
        } else if (!isEligible && giftItemsInCart.length > 0) {
            // Remove all gifts if no longer eligible
            for (const giftItem of giftItemsInCart) {
                await removeFreeGift(giftItem.key);
            }
        } else {
            debugLog("✅ Gift state is correct. No action needed.");
        }
 
        // Release processing lock
        isProcessing = false;
        debugLog("🔓 Gift check complete, releasing processing lock");
    }
 
    // Patch fetch to hook into AJAX updates (cart/add, cart/change)
    (function () {
        const originalFetch = window.fetch;
        window.fetch = async function (resource, config) {
        const response = await originalFetch(resource, config);
        if (typeof resource === "string" && resource.includes("/cart")) {
            try {
                response.clone().json().then(() => {
                    if (
                        response.url.includes("cart/add") ||
                        response.url.includes("cart/change")
                    ) {
                        // Reduce delay for faster response - only skip if already processing
                        if (!isProcessing) {
                            setTimeout(() => checkAndApplyGift(), 50);
                        }
                    }
                });
            } catch (err) {
                console.warn("⚠️ Fetch patch error:", err);
            }
        }
            return response;
        };
    })();
 
    // Initial eligibility check on page load
    checkAndApplyGift();
});